import React from 'react'

import HintPopover from '../hint-popover/hint-popover'
import GDSelectUserPopover from "./popover/popover"

// @ts-ignore
import GDSelectUserValueMulti from "./value/select-user-value-multi"
// @ts-ignore
import GDSelectUserValue from "./value/select-user-value"
// @ts-ignore
import { Deferred } from 'simply-deferred'

export const CUSTOM_TYPE   = 'custom'
export const NO_VALUE_TYPE = 'no-value'
export const USER_TYPE     = 'user'
export const ADD_TYPE      = 'add'

type OptionType = typeof CUSTOM_TYPE | typeof NO_VALUE_TYPE | typeof USER_TYPE | typeof ADD_TYPE

type SelectOption = {
    type : OptionType
    user?: {
        id: string
    }
}

interface FormInterface {
    getValue(name: string): string | string[]
    registerFormComponent(name: string, component: any): void
    onFormComponentValueChange(name: string, value: any): void
}

type Props = {
    defaultIcon?            : string

    value?                  : string | null
    values?                 : string[]
    options                 : string[]
    additionalOptions?      : any[]

    placeholder?            : string
    disabled?               : boolean
    className?              : string

    underlined?             : 'on-hover' | 'always' | 'never'

    avatarSize?             : string
    renderValue             : 'name' | 'icon-name' | 'icon' | 'inline' | 'form-icon-name' | 'form' | 'control' | 'func'
    renderValueFunc?        : func

    onTogglePopover?        : (show: boolean) => void
    onChange?               : (value: any) => void
    onUserSelect?           : (value: any) => void

    deleteButton?           : boolean

    canHaveNoValue?         : boolean
    noValueLabel?           : string
    noValueValue?           : any

    addUserLabel?           : string
    addUserCallback?        : func

    infoMessage?            : any

    onDisabledClick?        : func

    popoverFitTargetWidth?  : boolean
    popoverStyle?           : React.CSSProperties

    attachmentType?         : 'full' | 'vertical' | 'horizontal'
    attachment?             : string
    targetAttachment?       : string
    targetOffset?           : string
    popoverClass?           : string

    multiselect?            : boolean

    form?                   : FormInterface
    name?                   : string

    searchable?             : boolean
    keyboardNavigation?     : boolean
    hint?                   : string
}

type State = {
    showPopover         : boolean
    value?              : string
    values              : string[]
    searchString?       : string
    currentCursorKey    : any
}

export default class GDSelectUser extends React.Component<Props, State> {

    static defaultProps = {
        value               : null,
        values              : [],
        placeholder         : "Please select",
        options             : [],
        multiselect         : false,

        canHaveNoValue      : false,

        noValueValue        : null,

        avatarSize          : 'tiny',

        disabled            : false,

        attachmentType      : "full",
        attachment          : "top center",
        targetAttachment    : "bottom center",
        targetOffset        : "0 0",
        searchable          : true,
        keyboardNavigation  : true
    }

    constructor(props: Props) {
        super(props)

        let value: string | undefined
        let values: string[]     = []

        if (props.form) {
            if (props.multiselect) {
                values = (props.form.getValue(props.name!) as string[]) ?? []
            } else {
                value = props.form.getValue(props.name!) as string
            }
        } else {
            value  = props.value  ?? undefined
            values = props.values ?? []
        }

        this.state = {
            showPopover         : false,
            value               : value,
            values              : values,
            searchString        : undefined,
            currentCursorKey    : null
        }

        this.props.form?.registerFormComponent(this.props.name!, this)
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (nextProps.multiselect) {
            if (nextProps.form) {
                const formValue = (nextProps.form.getValue(nextProps.name!) as string[]) ?? []
                if (formValue !== this.state.values) {
                    this.setState({
                        values: formValue
                    })
                }
            } else {
                if (
                    nextProps.values
                    && nextProps.values !== this.state.values
                ) {
                    this.setState({
                        values: nextProps.values
                    })
                }
            }
        } else {
            if (nextProps.form) {
                const formValue = nextProps.form.getValue(nextProps.name!) as string
                if (formValue !== this.state.value) {
                    this.setState({
                        value: formValue
                    })
                }
            } else {
                if (
                    typeof nextProps.value !== 'undefined'
                    && nextProps.value !== this.state.value
                ) {
                    this.setState({
                        value: nextProps.value ?? undefined}
                    )
                }
            }
        }
    }

    UNSAFE_componentWillUpdate(nextProps: Props, nextState: State) {
        if (this.props.multiselect) {
            if (
                nextState.values !== this.state.values
                && this.props.onChange
            ) {
                this.props.onChange(nextState.values)
            }
        } else {
            if (
                nextState.value !== this.state.value
                && this.props.onChange
            ) {
                this.props.onChange(nextState.value)
            }
        }
    }

    togglePopover = () => {
        if (!this.props.disabled) {
            const showPopover = !this.state.showPopover
            this.setState({
                showPopover: showPopover
            }, () => {
                this.props.onTogglePopover?.(showPopover)
            })
        }
    }

    hidePopover = (selectedOption: SelectOption | null = null): any => {
        let searchString        = undefined
        let showPopover         = false
        let currentCursorKey    = null
        let value               = this.state.value
        let values              = this.state.values
        const stateChanged      = new Deferred()

        if (selectedOption) {
            switch (selectedOption.type) {
                case USER_TYPE:
                case CUSTOM_TYPE: {
                    const userId = selectedOption.user!.id
                    if (this.props.multiselect) {
                        values              = gd.utils.toggleArrayObject(values, userId, (id: string) => id === userId)
                        searchString        = this.state.searchString
                        showPopover         = true
                        currentCursorKey    = this.state.currentCursorKey
                    } else {
                        value = userId
                    }
                    break
                }
                case NO_VALUE_TYPE:
                    value  = this.props.noValueValue
                    values = []
                    break
            }
        }

        this.setState({
            searchString        : searchString,
            showPopover         : showPopover,
            currentCursorKey    : currentCursorKey,
            value               : value,
            values              : values,
        }, () => {
            stateChanged.resolve()
            this.props.onTogglePopover?.(false)
        })

        return stateChanged
    }

    onChangeCursorKey = (newValue: any) => {
        this.setState({
            currentCursorKey: newValue
        })
    }

    onDeleteClick = () => {
        this.onOptionSelected({
            type: NO_VALUE_TYPE
        })
        if (this.props.noValueValue === this.state.value) {
            this.props.onUserSelect?.(this.props.noValueValue)
        }
    }

    onOptionSelected = (option: SelectOption) => {
        const oldValue      = this.state.value
        const stateChanged  = this.hidePopover(option)

        if (!this.props.form && !this.props.onUserSelect) {
            return
        }

        switch (option.type) {
            case USER_TYPE:
            case CUSTOM_TYPE:
                if (this.props.multiselect) {
                    stateChanged.done(() => {
                        this.props.form?.onFormComponentValueChange(this.props.name!, this.state.values)
                        this.props.onUserSelect?.(this.state.values)
                    })
                } else {
                    const userId = option.user!.id
                    if (userId !== oldValue) {
                        this.props.form?.onFormComponentValueChange(this.props.name!, userId)
                        this.props.onUserSelect?.(userId)
                    }
                }
                break

            case NO_VALUE_TYPE:
                if (this.props.multiselect) {
                    this.props.form?.onFormComponentValueChange(this.props.name!, this.props.noValueValue)
                } else {
                    if (this.props.noValueValue !== oldValue) {
                        this.props.form?.onFormComponentValueChange(this.props.name!, this.props.noValueValue)
                        this.props.onUserSelect?.(this.props.noValueValue)
                    }
                }
                break

            case ADD_TYPE:
                this.props.addUserCallback?.()
                break
        }
    }

    onAddUserClick = () => {
        this.hidePopover()
        this.props.addUserCallback!()
    }

    onSearchChange = (newSearchString: string) => {
        this.setState({
            searchString: newSearchString
        })
    }

    onClick = () => {
        if (this.props.disabled) {
            this.props.onDisabledClick?.()
        }
    }

    renderValue = () => {
        return this.props.multiselect
            ?
            <GDSelectUserValueMulti
                {...this.props}
                showPopover     = {this.state.showPopover}
                values          = {this.state.values}
                onTogglePopover = {this.togglePopover}
            />
            :
            <GDSelectUserValue
                {...this.props}
                showPopover     = {this.state.showPopover}
                value           = {this.state.value}
                onTogglePopover = {this.togglePopover}
            />
    }

    render() {
        const classes = Classes('gd-select-user', this.props.className, "render-" + this.props.renderValue, {
            "is-disabled"           : this.props.disabled,
            "underlined-on-hover"   : this.props.underlined === 'on-hover',
            "underlined-always"     : this.props.underlined === 'always',
            "open"                  : this.state.showPopover,
            "with-delete"           : this.props.deleteButton,
            "multi-select"          : this.props.multiselect,
            "no-val"                : !(this.state.value && this.state.value !== this.props.noValueValue)
        })

        const showHint = this.props.hint && !this.state.showPopover

        return (
            <div className  = {classes}
                 onClick    = {this.onClick}
            >
                {this.renderValue()}

                {this.props.deleteButton &&
                    <div className  = "i5-delete-circle-solid"
                         onClick    = {this.onDeleteClick}
                    />
                }

                {showHint &&
                    <HintPopover hint={this.props.hint}/>
                }

                {this.state.showPopover &&
                    <GDSelectUserPopover
                        {...this.props}
                        value               = {this.state.value}
                        values              = {this.state.values}
                        searchString        = {this.state.searchString}
                        currentCursorKey    = {this.state.currentCursorKey}
                        onChangeCursorKey   = {this.onChangeCursorKey}
                        onOptionSelected    = {this.onOptionSelected}
                        onSearchChange      = {this.onSearchChange}
                        onAddUserClick      = {this.props.addUserCallback ? this.onAddUserClick : undefined}
                        onHidePopover       = {this.hidePopover}
                    />
                }
            </div>
        )
    }
}
